import { format as p, parse as l, addDays as E, isValid as _, isAfter as m } from "date-fns";
import c, { isEmpty as u, isNumber as d } from "lodash";
import o from "query-string";
class N {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/content-service/api/v1/display/components?${e}`
    });
  }
}
class A {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/content-service/api/v1/display/component-data?${e}`
    });
  }
}
class T {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/content-service/api/v1/display/display-info?${e}`
    });
  }
}
class D {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/content-service/api/v1/display/gnb-list?${e}`
    });
  }
}
class M {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/content-service/api/v1/display/template-info?${e}`
    });
  }
}
const r = (s, t) => {
  const e = new RegExp(`(^| )${s}=([^;]+)`), n = (t || "").match(e);
  if (n)
    return n[2];
}, h = (s) => {
  for (const t in s)
    s[t] === void 0 || s[t] === null ? delete s[t] : typeof s[t] == "object" && s[t] !== null && h(s[t]);
  return s;
};
class S {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t, e) {
    const n = o.stringify(t);
    let i;
    if (e) {
      const a = h({
        PCID: r("PCID", e),
        _hackle_hid: r("_hackle_hid", e)
      });
      i = c.isEmpty(a) ? void 0 : a;
    }
    return await this.httpClient.request({
      method: "GET",
      headers: i,
      url: `${this.host}/hanssem/display-service/api/v1/display/template/components?${n}`
    });
  }
}
class I {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t, e) {
    const n = o.stringify(t);
    let i;
    if (e) {
      const a = h({
        PCID: r("PCID", e),
        _hackle_hid: r("_hackle_hid", e)
      });
      i = c.isEmpty(a) ? void 0 : a;
    }
    return await this.httpClient.request({
      withCredentials: !0,
      headers: i,
      method: "GET",
      url: `${this.host}/hanssem/display-service/api/v1/display/template/components/datas?${n}`
    });
  }
}
class O {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t, e) {
    const n = o.stringify(c.omit(t, "componentId"));
    let i;
    if (e) {
      const a = h({
        PCID: r("PCID", e),
        _hackle_hid: r("_hackle_hid", e)
      });
      i = c.isEmpty(a) ? void 0 : a;
    }
    return await this.httpClient.request({
      withCredentials: !0,
      headers: i,
      method: "GET",
      url: `${this.host}/hanssem/display-service/api/v1/display/components/${t.componentId}/datas?${n}`
    });
  }
}
class v {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec() {
    return await this.httpClient.request({
      url: `${this.host}/hanssem/display-service/api/v1/scraps?timestamp=${(/* @__PURE__ */ new Date()).getTime()}`,
      method: "GET"
    });
  }
}
class g {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      url: `${this.host}/hanssem/display-service/api/v1/scraps`,
      method: "POST",
      body: t,
      data: t
    });
  }
}
class $ {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      url: `${this.host}/hanssem/display-service/api/v1/scraps`,
      method: "DELETE",
      body: t,
      data: t
    });
  }
}
class R {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = t;
    e.componentDataDate && Object.assign(e, {
      preViewDataTime: p(
        new Date(c.toNumber(e.componentDataDate)),
        "yyyy-MM-dd HH"
      )
    });
    const n = o.stringify(e);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/display-service/api/v1/display/template/components/preview?${n}`
    });
  }
}
class w {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = t;
    e.componentDataDate && Object.assign(e, {
      preViewDataTime: p(
        new Date(c.toNumber(e.componentDataDate)),
        "yyyy-MM-dd HH"
      )
    });
    const n = o.stringify(e);
    return await this.httpClient.request({
      withCredentials: !0,
      method: "GET",
      url: `${this.host}/hanssem/display-service/api/v1/display/template/components/datas/preview?${n}`
    });
  }
}
class B {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      withCredentials: !0,
      method: "GET",
      url: `${this.host}/hanssem/display-service/api/v1/popup-lists?${e}`
    });
  }
}
class P {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/common-service/api/v1/commons/cart/count?${e}`
    });
  }
}
class f {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/common-service/commons/notices`,
      body: t
    });
  }
}
class q {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/common-service/api/v1/commons/scraps`,
      body: t
    });
  }
}
class k {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/common-service/api/v1/commons/scraps/categories`,
      body: t
    });
  }
}
class x {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "POST",
      url: `${this.host}/hanssem/common-service/api/v1/commons/scraps`,
      body: t
    });
  }
}
class H {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "DELETE",
      url: `${this.host}/hanssem/common-service/api/v1/commons/scraps`,
      body: t
    });
  }
}
class V {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec() {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/common-service/api/v1/commons/scraps/count`
    });
  }
}
class b {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify(t);
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/hanssem/common-service/api/v1/commons/scraps/existence?${e}`
    });
  }
}
class Y {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec({
    domainNo: t = 0,
    maxCount: e = 10,
    mode: n = "s",
    ...i
  }) {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/api/suggest`,
      body: {
        target: "complete",
        domain_no: t,
        max_count: e,
        mode: n,
        ...i
      }
    });
  }
}
class W {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec({
    domainNo: t = 0,
    maxCount: e = 10,
    ...n
  }) {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/api/suggest`,
      body: {
        target: "related",
        domain_no: t,
        max_count: e,
        ...n
      }
    });
  }
}
class U {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec({
    domainNo: t = 0,
    maxCount: e = 10,
    ...n
  }) {
    return await this.httpClient.request({
      method: "GET",
      url: `${this.host}/api/rankings`,
      body: {
        domain_no: t,
        max_count: e,
        ...n
      }
    });
  }
}
class F {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    const e = o.stringify({ isComponent: "TRUE" });
    return await this.httpClient.request({
      method: "GET",
      // url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/evaluation/${req.gdsEvalNo}/detail`,
      url: `${this.host}/hanssem/goods-service/api/v1/goods/evaluation/${t.gdsEvalNo}/detail?${e}`
    });
  }
}
class X {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "POST",
      url: `${this.host}/hanssem/goods-service/api/v1/goods/evaluation/${t.gdsEvalNo}/detail/like`
    });
  }
}
class K {
  constructor(t, e) {
    this.host = t, this.httpClient = e;
  }
  async exec(t) {
    return await this.httpClient.request({
      method: "DELETE",
      url: `${this.host}/hanssem/goods-service/api/v1/goods/evaluation/${t.gdsEvalNo}/detail/like`
    });
  }
}
const z = "REMODELING", J = "MAIN", Q = "MALL", Z = "HOMEIDEA", j = "MOBILE", tt = "PC", et = "GnbRemodelingSection", st = "GnbRemodelingShop", nt = "GnbRemodelingGoods", it = "GnbRemodelingStart", ot = "GnbRemodelingEvent", at = "GnbRemodelingRehouse", ct = "card", rt = "home", ht = "sso", pt = "compo", lt = "best", Et = "weekRank", _t = "highest", mt = "shopping", ut = "review", dt = "event", Lt = "ALL", yt = "CS", Ct = "F", Gt = "D", Nt = "SV", At = "oulet", Tt = "brand", Dt = "brand_pick", Mt = "F", St = "all", It = "deal", Ot = "weekday", vt = "weekend", gt = "season", $t = "ha", Rt = "freepass", wt = "rdo", Bt = "recommend", Pt = "apartment", ft = "spaceandphoto", qt = "magazine", kt = "constcase", xt = "largeCategoryTemplateNo", Ht = "middleCategoryTemplateNo", Vt = "smallCategoryTemplateNo", bt = "shopIntAgntDetailTemplateNo", Yt = "mainMenuTemplateNo", Wt = "mainMenuTemplateCode", Ut = "M_APPDOWN", Ft = "DW_TEST", Xt = "JW_TEST", Kt = "HYO_TEST", zt = "HANSSEM_MAIN_PC", Jt = "HANSSEM_MAIN_M", Qt = "HF_MAIN_M", Zt = "CATEGORY_M", jt = (s, t) => t.startsWith("http") ? t : `${s}${t.startsWith("/") ? "" : "/"}${t}`, te = (s, t) => ({
  appLinkChannel: t,
  appLinkTarget: "LINK",
  appLinkVal: s,
  appLinkSubVal: ""
}), ee = (s, t, e) => {
  let n = "";
  return t !== "MALL" ? n = e === "PC" ? `${process.env.NEXT_PUBLIC_STORE_WEB_HOST}/category/${s}` : `${process.env.NEXT_PUBLIC_STORE_MWEB_HOST}/category/${s}` : n = e === "PC" ? `${process.env.NEXT_PUBLIC_WEB_HOST}/category/${s}` : `${process.env.NEXT_PUBLIC_MWEB_HOST}/category/${s}`, {
    applink: {
      appLinkTarget: "CATEGORY",
      appLinkVal: `${s}`,
      appLinkSubVal: "",
      appLinkChannel: t,
      linkUrl: n
    }
  };
}, se = (s, t) => ({
  appLinkTarget: "CATE",
  appLinkChannel: t,
  appLinkVal: `${s.categoryNo}`,
  appLinkSubVal: null,
  appLinkOption: {
    ctgNo: `${s.categoryNo}`,
    ctgNm: `${s.categoryName}`,
    ctgDepth: `${s.categoryLevel}`
  }
}), ne = (s) => {
  if (s && s.length > 0)
    try {
      let t = l(s, "yyyy.MM.dd", /* @__PURE__ */ new Date());
      return t.setHours(23), t.setMinutes(59), t.setSeconds(59), t.setMilliseconds(0), t = E(t, -1), _(t) ? m(/* @__PURE__ */ new Date(), t) : !1;
    } catch {
    }
  return !1;
}, L = (s, t) => Object.keys(t).length === 0 ? s : Object.entries(t).reduce(
  (e, [n, i]) => (i && e.searchParams.set(n, i), e),
  new URL(s)
).toString(), ie = ({
  url: s,
  w: t = 0,
  h: e = 0,
  q: n
}) => {
  if (u(s) || t === void 0 || e === void 0 || t === 0 || e === 0)
    return s;
  const i = d(n) && n > 0 && n <= 100 && n;
  return L(s, { w: t, h: e, q: i });
}, oe = ({
  url: s,
  w: t,
  h: e,
  q: n = 80,
  c: i = !1
}) => {
  const a = [
    t !== void 0 ? `w=${t}` : "",
    e !== void 0 ? `h=${e}` : "",
    n !== 80 ? `q=${n}` : "",
    i ? "c=c" : ""
  ].filter(Boolean).join("&");
  return a ? `${s}${s.includes("?") ? "&" : "?"}${a}` : s;
};
export {
  x as CreateScrapGateway,
  Xt as DISPLAY_SERVICE_GOODS,
  Kt as DISPLAY_SERVICE_HYO,
  Ft as DISPLAY_SERVICE_MAIN,
  Jt as DISPLAY_SERVICE_MAIN_MOBILE,
  Qt as DISPLAY_SERVICE_MAIN_MOBILE_HF,
  zt as DISPLAY_SERVICE_MAIN_PC,
  Zt as DISPLAY_SERVICE_MOBILE_CATEGORY,
  H as DeleteScrapGateway,
  $ as DeleteScraps,
  Pt as GNB_HOMEIDEA_APARTMENT,
  kt as GNB_HOMEIDEA_CONSTCASE,
  qt as GNB_HOMEIDEA_MAGAZINE,
  Bt as GNB_HOMEIDEA_RECOMMEND,
  ft as GNB_HOMEIDEA_SPACEANDPHOTO,
  lt as GNB_MALL_BEST,
  Tt as GNB_MALL_BRAND,
  ct as GNB_MALL_CARD,
  pt as GNB_MALL_COMPO,
  It as GNB_MALL_DEAL,
  dt as GNB_MALL_EVENT,
  rt as GNB_MALL_HOME,
  At as GNB_MALL_OULET,
  ht as GNB_MALL_SSO,
  ot as GNB_REMODELING_EVENT,
  nt as GNB_REMODELING_GOODS,
  at as GNB_REMODELING_REHOUSE,
  et as GNB_REMODELING_SECTION,
  st as GNB_REMODELING_SHOP,
  it as GNB_REMODELING_START,
  P as GetCartCountGateway,
  F as GetGoodsEvaluationDetailGateway,
  f as GetNoticesGateway,
  B as GetPopupLists,
  A as GetRemodelingComponentData,
  N as GetRemodelingComponentList,
  T as GetRemodelingDisplayInfo,
  D as GetRemodelingGnbList,
  M as GetRemodelingTemplateInfo,
  k as GetScrapCategoriesGateway,
  v as GetScraps,
  V as GetScrapsCountGateway,
  b as GetScrapsExistenceGateway,
  q as GetScrapsGateway,
  S as GetTemplateComponents,
  I as GetTemplateComponentsData,
  R as GetTemplateComponentsPreview,
  w as GetTemplateComponentsPreviewData,
  O as GetTemplateInfiniteComponentsData,
  Y as GetXSearchAutoCompleteGateway,
  U as GetXSearchRankingGateway,
  W as GetXSearchSuggestGateway,
  Yt as INFORMED_MAIN_MENU,
  Wt as INFORMED_MAIN_MENU_CODE,
  xt as INFORMED_REMODELING_GOODS_LARGE_CATEGORY,
  Ht as INFORMED_REMODELING_GOODS_MIDDLE_CATEGORY,
  Vt as INFORMED_REMODELING_GOODS_SMALL_CATEGORY,
  bt as INFORMED_SHOP_DETAIL_INTERIOR_AGENT,
  X as LikeGoodsEvaluationGateway,
  g as PostScraps,
  _t as SNB_MALL_BEST_HIGHEST,
  ut as SNB_MALL_BEST_REVIEW,
  mt as SNB_MALL_BEST_SHOPPING,
  Et as SNB_MALL_BEST_WEEKRANK,
  St as SNB_MALL_BRAND_ALL,
  Dt as SNB_MALL_BRAND_BRAND_PICK,
  Mt as SNB_MALL_BRAND_F,
  Rt as SNB_MALL_DEAL_FREEPASS,
  $t as SNB_MALL_DEAL_HA,
  wt as SNB_MALL_DEAL_RDO,
  gt as SNB_MALL_DEAL_SEASON,
  Ot as SNB_MALL_DEAL_WEEKDAY,
  vt as SNB_MALL_DEAL_WEEKEND,
  Lt as SNB_MALL_EVENT_ALL,
  yt as SNB_MALL_EVENT_CS,
  Gt as SNB_MALL_EVENT_D,
  Ct as SNB_MALL_EVENT_F,
  Nt as SNB_MALL_EVENT_SV,
  Ut as TEMPLATE_M_APPDOWN,
  j as TYPE_VALUE_MOBILE,
  tt as TYPE_VALUE_PC,
  K as UnlikeGoodsEvaluationGateway,
  Z as VIEW_TYPE_HOMEIDEA,
  J as VIEW_TYPE_MAIN,
  Q as VIEW_TYPE_MALL,
  z as VIEW_TYPE_REMODELING,
  L as appendQueryParams,
  jt as getCdnImage,
  ie as getResizeImage,
  oe as getResizeImageWithCrop,
  ne as isEnd,
  te as makeAppLink,
  se as makeAppLinkCate,
  ee as newMakeAppLinkCate,
  h as removeUndefinedValues
};
